import Component from '../abstracts/Component';
import { isMobile, MobileBreakpoint } from '../utils/MobileUtils';

export default class SalesScrollbarComponent extends Component {
  get SELECTORS() {
    return {
      scroller: '[data-scroller-menu]',
      scrollerBox: '[data-scroller-box]',
      items: '[data-scroller-menu] .w-sales__macro-category__tab'
    };
  }

  get CLASSES() {
    return {
      noscrollbar: 'noscrollbar',
    }
  }

  get COMPONENTNAME() {
    return 'SalesScrollbarComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);
    // elements
    this.scroller = this.$component.querySelector(this.SELECTORS.scroller);
    this.scrollerBox = this.$component.querySelector(this.SELECTORS.scrollerBox);
    this.items = this.$component.querySelectorAll(this.SELECTORS.items);
    this.item = this.items[0];
    this.scrollIndex = 0;
    this.offsetWidth = 0;
  }

  // load carousel
  importLibrary() {
    this.moduleLoader.loadSimpleBarAndExecute(
      module => {
        this.initSimpleBar(module.default);
        this.bindEvents();
        // events
        this.scrollbarEvents(module.default);
      },
      error => {
        console.log('failed to load SimpleBar ', error.stack);
      }
    );
  }

  calculateDimensions() {
    var scrollContainerOffset = 0;
    try {
      scrollContainerOffset = parseInt(
        window.getComputedStyle(this.scroller).paddingLeft
      );
      this.scrollOffset =
        scrollContainerOffset -
        this.component.querySelector(this.SELECTORS.titleContainer).offsetWidth;
    } catch (e) {
      this.scrollOffset = 0;
    }
    this.maxIndex = Math.max(
      0,
      this.items.length -
        Math.ceil(
          (this.scroller.offsetWidth - scrollContainerOffset) / this.offsetWidth
        )
    );
  }

  initSimpleBar(SimpleBar) {
    // check overflow
    let checkOverflow = this.checkOverflow(this.scrollerBox);
    // if i need the scrollbar
    if (!isMobile(MobileBreakpoint.Max767) && checkOverflow ) {
      // remove class
      this.scroller.classList.remove(this.CLASSES.noscrollbar);
      // launch simplebar
      this.simpleBar = new SimpleBar(this.scroller, {
        autoHide: false,
      });
    } else {
      // desktop and not overflow
      // add class
      this.scroller.classList.add(this.CLASSES.noscrollbar);
      // destroy simpleBar
      this.destroyScrollbar(this.simpleBar);
    }
  }

  destroyScrollbar(SimpleBar) {
    // take instance
    if (this.simpleBar != null) {
      // take old content
      let oldHtml = SimpleBar.contentEl.innerHTML;
      // replace it
      this.scroller.innerHTML = oldHtml;
      // destroy simplebar instance
      this.simpleBar = null;
    }

  }

  checkOverflow(elem) {
    return elem.scrollWidth > elem.clientWidth;
  }

  scrollbarEvents(SimpleBar) {
    // global
    let ctx = this;
    // event on scroll
    if (typeof this.simpleBar !== 'undefined') {
      this.simpleBar.getScrollElement().addEventListener('scroll', e => {
        this.calculateDimensions();
        var scrollLeft = e.target.scrollLeft - this.scrollOffset;
        if (scrollLeft <= 0) {
          this.scrollIndex = 0;
          return;
        }
        this.scrollIndex = Math.floor(scrollLeft / this.offsetWidth);
      });
    }
    // window resize
    window.addEventListener('resize', () => {
      // launch scrollbar on resize
      this.initSimpleBar(SimpleBar);
    });

  }

  // DOM events
  bindEvents() {
    // global
    let ctx = this;
    /*// dom load
    if (document.readyState !== 'loading') {
    } else {
      document.addEventListener('DOMContentLoaded', function () {
      });
    }*/
  }

  render() {
    this.log('Rendering...');
    // check and import
    if (document.querySelectorAll(this.SELECTORS.scroller)) this.importLibrary();
  }

}
